import {Injectable} from '@angular/core';

import {HttpClient} from "@angular/common/http";
import {PostProcessingRestClient} from "./post-processing.service";
import {AppState} from "../app-state";
import {AppConfig} from "../../../environments/environment";
import { RestClient } from './rest-client';

@Injectable({providedIn: 'root'})
export class OneSourceExportService {
    httpClient: PostProcessingRestClient

    constructor(
        private http: HttpClient,
        public appState: AppState,
    ) {
        this.httpClient = new PostProcessingRestClient(http, appState)
    }

    async exportOneSource() {
        try {
            const data: any = await this.httpClient.http.get(
                `${AppConfig.apiUrl}/onesource/download`,{ responseType: 'arraybuffer'}).toPromise()
            const filename = "OneSource-"+(new Date().getMonth()+1)+"-"+(new Date().getDate())+"-"+new Date().getFullYear()+".xlsx";
            let blob = new Blob([data], { type: "application/ms-excel" });
            saveAs(blob, filename);
        } catch (e: any) {
            console.error(e);
            const msg = `Onesource export error. ${RestClient.extractErrorMessage(e)}`
            this.appState.notifyError(msg,this,30);
        }
    }

}